import { Form, Input } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import React from 'react'
import styles from './TextInput.module.scss'

interface IProps extends FormComponentProps {
  rules?: any[]
  label?: string | React.ReactNode
  name: string
  onChange?: any
  inputProps?: any
  hasFeedback?: any
  placeholder?: any
  initialValue?: string
  normalize?: any
}

const TextInput: React.FC<IProps> = ({ form, rules = [], label, name, onChange, inputProps, hasFeedback = false, placeholder, initialValue, normalize }: IProps) => {
  const { getFieldDecorator } = form
  const [isRequired, setIsRequired] = React.useState(false)

  React.useEffect(() => {
    if (rules && rules.length && !isRequired) {
      setIsRequired(rules.find((item) => item.required === true))
    }
  }, [rules, isRequired])

  const handlerChange = (value: any) => {
    onChange && onChange(value)
  }

  const inputOptions = {
    rules,
    ...(normalize ? { normalize } : {}),
    ...(initialValue ? { initialValue } : {}),
  } as any

  return (
    <Form.Item className={styles.input} hasFeedback={hasFeedback} key={name} label={label || undefined} required={isRequired}>
      {getFieldDecorator(name, inputOptions)(<Input placeholder={placeholder || label} onChange={handlerChange} {...inputProps} />)}
    </Form.Item>
  )
}

export default TextInput
